import { render, staticRenderFns } from "./trendsmenu.vue?vue&type=template&id=6acbb8a0&scoped=true&"
import script from "./trendsmenu.vue?vue&type=script&lang=js&"
export * from "./trendsmenu.vue?vue&type=script&lang=js&"
import style0 from "./trendsmenu.vue?vue&type=style&index=0&id=6acbb8a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acbb8a0",
  null
  
)

export default component.exports